export const SharingRoutes = {
  event: 'event',
  lineup: 'lineup'
};
